export const equipmentGridSwitch = {
    bindings: {
        identifier: '@',
        module: '@'
    },
    template: require('./equipment-grid-switch.html'),
    controller: 'EquipmentGridSwitchController'
};
